import React, { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'
import { RootState } from '../../../states/containers/store'
import { isAdministrator, isMaster } from '../../../utils/role'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import classNames from 'classnames'

type LangValue = "ja" | "en"

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

interface SettingListItem {
  name: string
  icon: IconProp
  path: string
}

const SideBarSubSetting: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    commonPart,
    login,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  const [personal, setPersonal] = useState<boolean>(true)
  const [common, setCommon] = useState<boolean>(true)

  const personalSetting: SettingListItem[] = [
    {
      name: "プロフィールの設定",
      icon: ["fas", "id-card"],
      path: URL.SETTING_PROFILE.path,
    },
    {
      name: "Qasee Clientのダウンロード",
      icon: ["fas", "download"],
      path: URL.SETTING_CLIENT_DOWNLOAD.path,
    },
    {
      name: "多要素認証の設定",
      icon: ["fas", "key"],
      path: URL.SETTING_MFA_AUTH.path,
    },
    {
      name: "外部サービス連携",
      icon: ["fas", "user-cog"],
      path: URL.SETTING_OAUTH.path,
    },
    {
      name: "配信メール設定",
      icon: ["fas", "envelope"],
      path: URL.SETTING_MAIL_DELIVERY.path,
    },
    {
      name: "あなたの計測時間設定",
      icon: ["fas", "stopwatch"],
      path: URL.SETTING_INDIVIDUAL_MEASUREMENT.path,
    },
  ]
  const commonSetting: SettingListItem[] = [
    {
      name: "メンバー設定",
      icon: ["fas", "user-friends"],
      path: URL.SETTING_MEMBER.path,
    },
    {
      name: "チーム設定",
      icon: ["fas", "users"],
      path: URL.SETTING_TEAM.path,
    },
    {
      name: "契約情報",
      icon: ["fas", "file-contract"],
      path: URL.SETTING_CONTRACT.path,
    },
    {
      name: "勤務時間・休日設定",
      icon: ["far", "calendar-alt"],
      path: URL.SETTING_HOLIDAY_SCHEDULE.path,
    },
    {
      name: "チーム・メンバー 一括設定",
      icon: ["fas", "users-cog"],
      path: URL.SETTING_IMPORT_CSV.path,
    },
    {
      name: "管理者権限設定",
      icon: ["fas", "user-shield"],
      path: URL.SETTING_ADMIN.path,
    },
    {
      name: "打刻データ連携設定",
      icon: ["fas", "link"],
      path: URL.SETTING_RECODE_API_CONNECT.path,
    },
    {
      name: "配信メール・通知言語設定",
      icon: ["fas", "language"],
      path: URL.SETTING_LANGUAGE.path,
    },
    {
      name: "計測時間設定",
      icon: ["fas", "stopwatch"],
      path: URL.SETTING_MEASUREMENT.path,
    },
    {
      name: "Webブラウザの詳細表示設定",
      icon: ["fas", "info-circle"],
      path: URL.SETTING_WEB_BROWSER.path,
    },
    {
      name: "計測停止の制限設定",
      icon: ["fas", "stop-circle"],
      path: URL.SETTING_MEASUREMENT_RESTRICTION.path,
    },
    {
      name: "IPアドレス制限設定",
      icon: ["fas", "map-marker-alt"],
      path: URL.SETTING_IP_RESTRICTION.path,
    },
    {
      name: "オフィスのIPアドレス設定",
      icon: ["fas", "map-marker-alt"],
      path: URL.SETTING_OFFICE_IP_ADDRESS.path,
    },
    {
      name: "APIキー設定",
      icon: ["fas", "link"],
      path: URL.SETTING_EXTERNAL_API_KEY.path,
    },
  ]

  return (
    <>
      {
        location.pathname.match(URL.SETTING.path) && !commonPart.isLoading ? (
          <div className="side_sub_wrap">
            <div className="setting">
              <div className="tools">
                <div className="setting_menu">
                  <button
                    type="button"
                    className={`setting_toggle ${isOpen && "display"}`}
                    onClick={() => toggleCallback()}
                  >
                    <div className={`menu ${isOpen && "active"}`}>
                      <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                    </div>
                  </button>
                </div>
              </div>
              <section className="side_sub">
                <div
                  className="item folder"
                  onClick={() => setPersonal(!personal)}
                  role="none"
                >
                  <div className="name_label">
                    <FontAwesomeIcon
                      icon={['fas', 'angle-down']}
                      className={`arrow_icon ${personal && "open"}`}
                    />
                    <div className="name_area">
                      <FontAwesomeIcon
                        icon={['fas', 'cogs']}
                        className="icon task"
                      />
                      個人設定
                    </div>
                  </div>
                </div>
                <div className={`${personal || "hidden none"}`}>
                  {personalSetting.filter((v) => (
                    !(v.path === URL.SETTING_INDIVIDUAL_MEASUREMENT.path && !login.editable_weekly_track_time)
                  )).map((item) => (
                    <div key={item.name}>
                      <Link
                        to={setPath(item.path, language)}
                        className={classNames({
                          active: location.pathname.match(item.path),
                          item: true,
                          indent_1: true,
                        })}
                        key={item.path}
                      >
                        <div className="name_label">
                          <FontAwesomeIcon
                            icon={['fas', 'angle-right']}
                            className="arrow_icon"
                          />
                          <div className="name_area">
                            <FontAwesomeIcon icon={item.icon} className="icon task" />
                            {item.name}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
                {isAdministrator(commonPart.role) && (
                  <>
                    <div
                      className="item folder"
                      onClick={() => setCommon(!common)}
                      role="none"
                    >
                      <div className="name_label">
                        <FontAwesomeIcon
                          icon={['fas', 'angle-down']}
                          className={`arrow_icon ${common && "open"}`}
                        />
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'cogs']}
                            className="icon task"
                          />
                          共通設定
                        </div>
                      </div>
                    </div>
                    <div className={`${common || "hidden none"}`}>
                      {
                        commonSetting.map((item) => (
                          <>
                            {
                              (!commonPart.payment_finished || !login.change_contract) && item.name === "契約情報" ? (
                                <></>
                              ) : item.name === 'APIキー設定' && login.external_api === 'none' ? (
                                // MEMO: 暫定的にAPI連携が無効化されている場合はAPIキー設定を表示しない
                                <></>
                              ) : (
                                <>
                                  <Link
                                    to={setPath(item.path, language)}
                                    className={classNames({
                                      active: location.pathname.match(item.path),
                                      item: true,
                                      indent_1: true,
                                    })}
                                    key={item.path}
                                  >
                                    <div className="name_label">
                                      <FontAwesomeIcon
                                        icon={['fas', 'angle-right']}
                                        className="arrow_icon"
                                      />
                                      <div className="name_area">
                                        {
                                          isMaster(commonPart.role) && item.name === "チーム設定" && !commonPart.teams?.length && (
                                            <div className="attention" />
                                          )
                                        }
                                        <FontAwesomeIcon icon={item.icon} className="icon task" />
                                        {item.name}
                                      </div>
                                    </div>
                                  </Link>
                                </>
                              )
                            }
                          </>
                        ))
                      }
                    </div>
                  </>
                )}
              </section>
            </div>
          </div>
        ) : (
          <></>
        )
      }
    </>
  )
}

export default SideBarSubSetting
